import { AlertTriangle } from "lucide-react";

/**
 * R110.175 — Highlighted "₹999 vs cost of a wrong pick" nudge. Used on
 * venture pages, Matches, and Compare so the pay anchor is impossible to
 * miss. ₹999 gets an extra underline-highlight inside the text.
 */
export function RiskNudge({ text, testId = "risk-nudge" }) {
  const parts = String(text).split("₹999");
  return (
    <div
      data-testid={testId}
      className="inline-flex items-start gap-2 rounded-xl border border-amber-300 bg-amber-50 px-3.5 py-2 shadow-sm"
    >
      <AlertTriangle className="h-4 w-4 text-amber-600 mt-0.5 shrink-0" />
      <span className="text-xs sm:text-sm font-semibold text-amber-900 leading-snug">
        {parts[0]}
        {parts.length > 1 && (
          <b className="text-amber-950 underline decoration-amber-400 decoration-2 underline-offset-2">₹999</b>
        )}
        {parts[1]}
      </span>
    </div>
  );
}

export default RiskNudge;
